export default __webpack_public_path__ + "static/media/d.fa601d81.mp3";